import Box from '@mui/material/Box'

import { AppShellHeaderSearch } from '@/shared/components/AppShell/AppShellHeaderSearch'
import type { CampaignLandingFilter } from '@/features/campaigns/lib/campaign-landing-display'

import { ADMIN_DASHBOARD_LAYOUT } from '../lib/admin-dashboard-layout'
import { RecentCampaignsStatusFilter } from './RecentCampaignsStatusFilter'

interface Props {
  search: string
  onSearchChange: (value: string) => void
  statusFilter: CampaignLandingFilter
  onStatusFilterChange: (value: CampaignLandingFilter) => void
}

export function RecentCampaignsToolbar({
  search,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
}: Readonly<Props>) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { sm: 'center' },
        gap: { xs: 2, sm: ADMIN_DASHBOARD_LAYOUT.toolbarGap },
        flex: { xs: '1 1 100%', sm: '0 0 auto' },
      }}
    >
      <AppShellHeaderSearch
        value={search}
        onChange={onSearchChange}
        placeholder="Search by Campaign"
        testId="admin-dashboard-campaigns-search"
        ariaLabel="Search by Campaign"
      />
      <RecentCampaignsStatusFilter value={statusFilter} onChange={onStatusFilterChange} />
    </Box>
  )
}
